module.exports = __webpack_public_path__ + "static/media/draw-survey.3ad8a05b.svg";